import $ from 'jquery';

export default class Ajax {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        let self = this;

        $(() => {
            $('body')
                .on("click", "a[data-opd-remote]", function(e) {
                    e.preventDefault();
                    return self.fireRemoteAction(this);
                })
                .on("submit", "form[data-opd-remote]", function(e) {
                    e.preventDefault();
                    return self.submitRemoteForm(this);
                });
        })
    }

    /**
     * Fires the remote action
     * 
     * @param  {object} el
     * @return {boolean}
     */
    fireRemoteAction(el) {
        const self         = this;
        const $el          = $(el);
        const href         = $el.attr("data-action") || $el.attr("href");
        let method         = $el.attr("data-remote") ? $el.attr("data-remote").toLowerCase() : 'get';
        const id           = $el.attr("data-id");
        const before       = this.parseCallback($el.attr("data-before"));
        const after        = this.parseCallback($el.attr("data-after"));
        const callback     = this.parseCallback($el.attr("data-callback"));
        let redirectUrl    = $el.attr("data-redirect");
        const confirmation = $el.attr("data-confirm");
        const sendData     = {_token: this.token};
        const successMsg   = $el.attr("data-success-message");
        const errorMsg     = $el.attr("data-error-message");

        // Simulate PUT, PATCH and DELETE requests
        if (method === 'put' || method === 'patch' || method === 'delete') {
            sendData._method = method;
            method = 'post';
        }

        // Add the ID
        if (id) sendData.id = id;

        // Before action
        if (before) before($el);

        // Confirmation
        if (confirmation) {
            if ( ! self.confirm(confirmation)) {
                return false;
            }
        }

        if (href && method) {
            $.ajax({
                url:      href,
                data:     sendData,
                type:     method,
                dataType: 'json',
                success: function(response) {
                    // Call the callback method if defined
                    if (callback)               callback(response, $el);
                    else if (response.redirect) document.location = response.redirect;

                    if ( ! response.redirect && ! redirectUrl) {
                        self.alert(
                            null,
                            (response.message ? response.message : successMsg),
                            (response.message_type ? response.message_type : null)
                        );
                    }
                },
                error: function(el) {
                    const message = (el.responseJSON.message ? el.responseJSON.message : errorMsg);
                    if (message) self.alert(null, message, "error");
                },
                complete: function(response) {
                    if (after)            after(response, $el);
                    else if (redirectUrl) document.location = redirectUrl;
                }
            });
        }

        return false;
    }

    /**
     * Submit the form via ajax
     *
     * @param  {object} el
     * @return {boolean}
     */
    submitRemoteForm(el) {
        const self         = this;
        const $el          = $(el);
        const href         = $el.attr("action");
        let method         = $el.attr("data-remote") ? $el.attr("data-remote") : ($el.find("input[name=_method]").val() ? $el.find("input[name=_method]").val() : 'post');
        const before       = this.parseCallback($el.attr("data-before"));
        const after        = this.parseCallback($el.attr("data-after"));
        const callback     = this.parseCallback($el.attr("data-callback"));
        const redirectUrl  = $el.attr("data-redirect");
        const confirmation = $el.attr("data-confirm");
        const sendData     = this.serializeObject(el);
        const successMsg   = $el.attr("data-success-message");
        const errorMsg     = $el.attr("data-error-message");

        // Simulate PUT, PATCH and DELETE requests
        if (method === 'put' || method === 'patch' || method === 'delete') {
            sendData._method = method;
            method = 'post';
        }

        // Before action
        if (before) before($el);

        // Confirmation
        if (confirmation) {
            if ( ! self.confirm(confirmation)) {
                return false;
            }
        }

        if (href && method) {
            $.ajax({
                url:      href,
                data:     sendData,
                type:     method,
                dataType: 'json',
                success: function(response) {
                    // Call the callback method if defined
                    if (callback)               callback(response, $el);
                    else if (response.redirect) document.location = response.redirect;

                    self.alert(null, response.message ? response.message : "Success", response.message_type ? response.message_type : null);
                },
                error: function(el) {
                    const message = ((el.responseJSON && el.responseJSON.message) ? el.responseJSON.message : errorMsg);
                    if (message) self.alert("Error", message, "error");
                },
                complete: function(response) {
                    if (after)            after(response, $el);
                    else if (redirectUrl) document.location = redirectUrl;
                }
            });
        }

        return false;
    }

    /**
     * Parse the callback string
     * 
     * @param  {string} callback
     * @return {Function}
     */
    parseCallback(callback) {
        if (callback) {
            return new Function(callback);
        }
    }

    /**
     * Confirmation
     *
     * @param  {string} message
     * @return {boolean}
     */
    confirm(message) {
        return window.confirm(message);
    }

    /**
     * Serialize form data to JSON object
     *
     * @param  {object} el
     * @return {object}
     */
    serializeObject(el) {
        if ( ! $.fn.serializeArray) {
            return null;
        }

        var serialized = $(el).serializeArray();

        // Make sure that unchecked
        // inputs have default value
        // This way hidden inputs are avoided
        $(el).find("input:checkbox").each(function() {
            if (this.checked)
                return true;

            serialized.push({
                name: this.name,
                value: this.checked ? this.value : "0",
            });
        });

        return serialized;
    }

    /**
     * Show a notification
     * 
     * @type {void}
     */
    alert(title, message, alertType = "error") {
        if ( ! title && alertType === "error")   title = "Error";
        if ( ! title && alertType === "success") title = "Success";
        if ( ! alertType)                        alertType  = "success";

        if (message) {
            window.OPDashboard.Helpers.notify(message, alertType);
        }
    }
}
